<template>
    <div class="zhima">
        <Header tit="芝麻信用" color="1"></Header>
        <div class="authorize-zhima-title">
            <img class="authorize-logo" src="@/assets/my/t1ndlgxethxxxxxxxx.jpg" />
        </div>
        <div class="protocol-auth-detail">
            <div calss="protocol-detail-title">点击“同意授权”即表示你已阅读并同意以下内容：</div>
            <div class="protocol-detail-content">
                <div class="protocol-detail-content">
                    <div class="protocol-detail-content-ul">
                        <div>授权本平台向芝麻信用及其合作机构传递你的姓名、身份证号、手机号等信息，用于身份核验。</div>
                        <div>授权本平台查询你的芝麻分及相关信用信息，用于评估你与本平台的交易/服务条件。</div>
                        <div class="tit">特别提示</div>
                        <div>如发生逾期或其他不良行为影响信用：</div>
                        <div>1. 你授权芝麻信用根据借款服务需要提供可联系到你的手机号、地址等信息，用于联系与催收。</div>
                        <div>2. 芝麻信用将记录你的违约情况，并依法向相关方提供，可能影响你的信用生活服务（如借款等）。</div>
                    </div>
                </div>
            </div>
        </div>
        <BigBtn label="同意授权" class="sq"></BigBtn>
        <div class="what_zhima gray_color" @click="$router.push({name:'what_zhima'})">什么是芝麻信用</div>
    </div>
</template>

<script>
import Header from "../public/header";
import BigBtn from "../public/button";
export default {
    components: { Header, BigBtn },
    data() {
        return {
            phone: "", //手机号码
            code: "", //验证码
            code_count_down: 0, //验证码倒计时
            play: null //验证码定时器
        };
    },
    beforeDestroy() {
        clearInterval(this.play);
    },
    methods: {
        click_BigBtn() {
            this.$router.push({ name: "zhima_sq" });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.zhima {
    background: #ffffff;
    .authorize-zhima-title {
        width: 100%;
        height: 1.6rem;
        background: #fff;
        border-bottom: 2px solid #00c68d;
        padding-top: 0.3rem;
    }
    .authorize-logo {
        display: block;
        width: 3.3rem;
        margin: 0 auto;
    }
    .protocol-detail-content-ul div {
        margin-bottom: 10px;
    }
    .protocol-detail-content-ul .tit {
        font-weight: bold;
    }
    .protocol-auth-detail{
        padding-top: .2rem;
    }
    .sq {
        margin-top: 0.4rem;
    }
    .what_zhima {
        text-align: right;
        margin-top: 0.2rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/my/zhima.vue